// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_d50","cls2":"AuthorHeader-cls2_PZn AuthorHeader-cls1_d50"};